// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryValueData } from './HistoryValueData';
import {
    HistoryValueDataFromJSON,
    HistoryValueDataFromJSONTyped,
    HistoryValueDataToJSON,
    HistoryValueDataToJSONTyped,
} from './HistoryValueData';

/**
 * 
 * @export
 * @interface HistoryReadResponseData
 */
export interface HistoryReadResponseData {
    /**
     * Historical data for all value variables in the function
     */
    values: Array<HistoryValueData>;
}

/**
 * Check if a given object implements the HistoryReadResponseData interface.
 */
export function instanceOfHistoryReadResponseData(value: object): value is HistoryReadResponseData {
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function HistoryReadResponseDataFromJSON(json: any): HistoryReadResponseData {
    return HistoryReadResponseDataFromJSONTyped(json, false);
}

export function HistoryReadResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryReadResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'values': ((json['values'] as Array<any>).map(HistoryValueDataFromJSON)),
    };
}

export function HistoryReadResponseDataToJSON(json: any): HistoryReadResponseData {
    return HistoryReadResponseDataToJSONTyped(json, false);
}

export function HistoryReadResponseDataToJSONTyped(value?: HistoryReadResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'values': ((value['values'] as Array<any>).map(HistoryValueDataToJSON)),
    };
}

